import * as toastr from 'toastr';
import '../scss/styles.scss';
import './main';
import 'bootstrap';
import './dashboard';
import { ValidationManager } from './validationManager';
import { BudgetControl } from './components/budget';
import { BudgetPickerControl } from './components/budgetPicker';
import { chunkedFileUpload } from './chunkedFileUpload';
import { initPortalFileUpload } from './components/portalFileUpload';
import { initAiFormFill } from './components/aiFormFill';
import registerGridConfigurator from './components/gridConfigurator/GridConfigurator';
import registerImagePicker from './components/imagePicker/ImagePicker';
import registerImageGallery from './components/imageGallery/ImageGallery';
import { enableToggleAll, enableHierarchyToggle } from './toggle-checkbox';
import { registerDocsChatWidget } from './components/docsChat/DocsChatWidget';
import { registerTaskflowGraph } from './components/taskflow/registerTaskflowGraph';
import { registerReportingWidget } from './components/reportingWidget/ReportingWidget';

window.toastr = toastr;

export { ValidationManager, BudgetControl, BudgetPickerControl, chunkedFileUpload, initPortalFileUpload, initAiFormFill, registerGridConfigurator, registerImagePicker, enableToggleAll, enableHierarchyToggle, registerImageGallery, registerDocsChatWidget, registerTaskflowGraph, registerReportingWidget };
